export enum SettingEventsEnum {
  APP_VIEW_TO_MAIN_GET_STORAGE_ITEMS = 'APP_VIEW_TO_MAIN_GET_STORAGE_ITEMS',
  APP_VIEW_TO_MAIN_SET_STORAGE_ITEMS = 'APP_VIEW_TO_MAIN_SET_STORAGE_ITEMS',
  APP_VIEW_TO_MAIN_SET_STORAGE_ITEM = 'APP_VIEW_TO_MAIN_SET_STORAGE_ITEM',
  MAIN_TO_APP_VIEW_SHOW_SETTINGS_MODAL = 'MAIN_TO_APP_VIEW_SHOW_SETTINGS_MODAL',
}
